import React from 'react'
import { resolveComponentForOperator } from 'components/ContactFilterBuilder/constants/PropertyComponents'

const IsNotAfter = ({ property, onChange }) => {  

  const PropertyComponent = resolveComponentForOperator(property.type, 'IS_NOT_AFTER')

  return (
    <div>
      <PropertyComponent
        property={property}
        onChange={onChange}
        isOperator={true}
      />
    </div>
  )
}

export default IsNotAfter
